import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-x-4 bottom-4 z-40 ml-auto max-w-sm rounded-xl bg-white shadow-2xl ring-1 ring-gray-900/15 overflow-hidden sm:inset-x-auto sm:bottom-8 sm:right-8 sm:w-[32rem] sm:max-w-none"
}
const _hoisted_2 = { class: "flex flex-col sm:flex-row" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "flex min-w-0 flex-1 flex-col justify-between p-6" }
const _hoisted_5 = { class: "pr-6" }
const _hoisted_6 = { class: "mt-3 text-base font-bold leading-snug text-dbBlue" }
const _hoisted_7 = { class: "mt-3 line-clamp-3 text-sm text-gray-500" }
const _hoisted_8 = { class: "mt-5 flex items-center justify-between" }
const _hoisted_9 = ["href"]

import {
		XMarkIcon
	} from "@heroicons/vue/20/solid"

	import {
		ArrowTopRightOnSquareIcon
	} from "@heroicons/vue/24/outline"

	import {
		onMounted
	} from "vue"

	import api from "@/utilities/api"

	
	import {
		ref
	} from "vue"

	const __default__ = { name: "BlogPostPopup" } // name the component

	// module-scoped so a dismissal survives route navigation but resets on a full page reload
	const dismissed = ref(false)

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	const POPUP_DELAY_MS = 1500

	const show = ref(false)
	const post = ref<{title: string, description: string, imageUrl: string | null, date: string, url: string} | null>(null)

	const dateFormatter = new Intl.DateTimeFormat("en-US", {
		year: "numeric",
		month: "long",
		day: "numeric"
	})

	onMounted(() => {
		if (!dismissed.value) {
			getLatestBlogPost()
		}
	})

	// hide the popup and remember the dismissal for the rest of this browser session
	function dismiss() {
		show.value = false
		dismissed.value = true
	}

	// resolves once the image is cached by the browser (or has failed), so it never flashes in on display
	function preloadImage(url: string) {
		return new Promise<void>((resolve) => {
			const img = new Image()
			img.onload = () => resolve()
			img.onerror = () => resolve()
			img.src = url
		})
	}

	// fetch the newest published blog entry relevant to the user's typeOfWork (falling back to the newest overall), then reveal the popup after a short delay
	async function getLatestBlogPost() {
		try {
			const response = await api("get", "fmDataAPI", "/latest-blog-post")

			if (!response.post) {
				return
			}

			post.value = {
				...response.post,
				date: dateFormatter.format(new Date(response.post.date))
			}

			const delay = new Promise((resolve) => setTimeout(resolve, POPUP_DELAY_MS))
			const imageReady = post.value.imageUrl ? preloadImage(post.value.imageUrl) : Promise.resolve()

			await Promise.all([delay, imageReady])

			if (!dismissed.value) {
				show.value = true
			}
		}
		catch(e) {
			console.error(e)
		}
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    "enter-active-class": "transition ease-out duration-500",
    "enter-from-class": "opacity-0 translate-y-4",
    "enter-to-class": "opacity-100 translate-y-0",
    "leave-active-class": "transition ease-in duration-200",
    "leave-from-class": "opacity-100 translate-y-0",
    "leave-to-class": "opacity-0 translate-y-4"
  }, {
    default: _withCtx(() => [
      (show.value && post.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("button", {
              type: "button",
              class: "absolute top-2 right-2 rounded-full bg-white p-1.5 text-gray-400 shadow-sm hover:text-gray-600",
              onClick: dismiss
            }, [
              _createVNode(_unref(XMarkIcon), { class: "h-5 w-5" })
            ]),
            _createElementVNode("div", _hoisted_2, [
              (post.value.imageUrl)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: post.value.imageUrl,
                    alt: post.value.title,
                    class: "aspect-video w-full flex-shrink-0 object-cover sm:aspect-square sm:w-44"
                  }, null, 8, _hoisted_3))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "text-xs font-semibold uppercase tracking-wide text-indigo-500" }, " Latest Blog Post ", -1)),
                  _createElementVNode("h3", _hoisted_6, _toDisplayString(post.value.title), 1),
                  _createElementVNode("p", _hoisted_7, _toDisplayString(post.value.description), 1)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("a", {
                    href: post.value.url,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    class: "inline-flex items-center gap-1 text-sm font-semibold text-indigo-600 hover:text-indigo-800",
                    onClick: dismiss
                  }, [
                    _cache[1] || (_cache[1] = _createTextVNode(" Read More ")),
                    _createVNode(_unref(ArrowTopRightOnSquareIcon), { class: "h-4 w-4 shrink-0" })
                  ], 8, _hoisted_9)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})